import { Box, CircularProgress } from '@mui/material'
import { useState } from 'react'

import { useOptions } from '../../../providers/Options/Options.provider'
import { useProviderDetails } from '../../../providers/ProviderDetails/ProviderDetails.provider'
import { ProviderInformation } from '../../../providers/ProviderDetails/types'
import { useProviders } from '../../../providers/ProvidersProvider/ProvidersProvider.provider'
import { Provider } from '../../../providers/ProvidersProvider/types'
import { ProvidersView } from './Providers.view'
import { ViewType } from './types'

const Providers = () => {
  const { providers, providerAccessRoles, updateProviderAccessRole } =
    useProviders()
  const { optionsLoading } = useOptions()

  const { myProviderDetails, getProviderInfo } = useProviderDetails()

  const [viewMode, setViewMode] = useState<ViewType>(ViewType.List)

  const [editProviderModal, setEditProviderModal] = useState<boolean>(false)

  const [editScheduleLinkModal, setEditScheduleLinkModal] =
    useState<boolean>(false)

  const [selectedProvider, setSelectedProvider] = useState<Provider | null>(
    null
  )

  const [selectedScheduleProvider, setSelectedScheduleProvider] =
    useState<ProviderInformation | null>(null)

  const handleEditProviderModal = (selectedProviderID: number) => {
    const selectedProvider = providers?.find(
      (p) => p.providerId === selectedProviderID
    )
    if (selectedProvider) {
      setSelectedProvider(selectedProvider)
      setEditProviderModal(true)
    }
  }

  const handleEditScheduleProviderModal = async (
    selectedProviderID: number
  ) => {
    const selectedScheduleProviderInfo = await getProviderInfo(
      selectedProviderID
    )

    if (selectedScheduleProviderInfo) {
      setSelectedScheduleProvider(selectedScheduleProviderInfo)
      setEditScheduleLinkModal(true)
    }
  }

  // for refreshing data after changing provider schedule link visibility in the modal
  const handleRefetchScheduleProvider = async () => {
    if (selectedScheduleProvider?.id) {
      const updatedProviderInfo = await getProviderInfo(
        selectedScheduleProvider.id
      )
      if (updatedProviderInfo) {
        setSelectedScheduleProvider(updatedProviderInfo)
      }
    }
  }

  const handleEditProviderAccess = async (
    selectedProvider: Provider,
    accessRoleId: number
  ): Promise<void> => {
    await updateProviderAccessRole(selectedProvider.providerId, accessRoleId)
  }

  return providers && providers.length > 0 && !optionsLoading ? (
    <ProvidersView
      viewMode={viewMode}
      myProviderDetails={myProviderDetails}
      providers={providers}
      providerAccessRoles={providerAccessRoles}
      selectedProvider={selectedProvider}
      editProviderModal={editProviderModal}
      setEditProviderModal={setEditProviderModal}
      handleEditProviderModal={handleEditProviderModal}
      handleEditScheduleProviderModal={handleEditScheduleProviderModal}
      handleEditProviderAccess={handleEditProviderAccess}
      selectedScheduleProvider={selectedScheduleProvider}
      editScheduleLinkModal={editScheduleLinkModal}
      setEditScheduleLinkModal={setEditScheduleLinkModal}
      onRefetchScheduleProvider={handleRefetchScheduleProvider} // Add this
    />
  ) : (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />{' '}
    </Box>
  )
}

export { Providers }
